import GraphContent from "../graph_content";
import { defaultRange, defaultThreshold } from "./default_values";
import { Threshold } from "@/types/types";

export function setInitSetting(self: GraphContent) {
  Object.keys(self.mst_graph).forEach((keyName: string) => {
    if (keyName === "mails") {
      self[keyName] = self.mst_graph.mails.join(",");
    } else if (keyName === "thresholdSettings") {
      self.thresholdSettings = {};
      self.mst_graph.attributes.forEach((key: string, index: number) => {
        self.thresholdSettings[key] = defaultThreshold;
        self.attributeValueColors[key] = "#32c201";
        if (index === 0) {
          self.selectedThresholdKey = key;
        }
      });
      if (self.mst_graph.thresholdSettings !== null) {
        const parseThresholdSettings: { [k: string]: Threshold } = JSON.parse(
          self.mst_graph.thresholdSettings
        );
        Object.keys(parseThresholdSettings).forEach((key: string) => {
          self.thresholdSettings[key] = parseThresholdSettings[key];
          if (self.selectedThresholdKey === key) {
            self.selectedThreshold = parseThresholdSettings[key];
          }
        });
      }
    } else if (keyName === "thresholdSettingsList") {
      self.addThresholdSettingArea = [
        {
          addSelectedThresholdKey: "",
          addSelectedThreshold: {
            max: {
              enabled: false,
              value: 0
            },
            min: {
              enabled: false,
              value: 0
            }
          }
        }
      ];
      // 配列型かどうか判定するための補助関数
      const toString = Object.prototype.toString;
      if (
        toString.call(self.mst_graph.thresholdSettingsList) ===
          "[object Array]" &&
        self.mst_graph.thresholdSettingsList.length > 0
      ) {
        self.addThresholdSettingArea = [];
        if (self.mst_graph.thresholdSettings !== null) {
          const parseThresholdSettings: { [k: string]: Threshold } = JSON.parse(
            self.mst_graph.thresholdSettings
          );
          for (const thresholdSettingKey of self.mst_graph
            .thresholdSettingsList) {
            self.addThresholdSettingArea.push({
              addSelectedThresholdKey: thresholdSettingKey,
              addSelectedThreshold: {
                max: {
                  enabled:
                    parseThresholdSettings[thresholdSettingKey].max.enabled,
                  value: parseThresholdSettings[thresholdSettingKey].max.value
                },
                min: {
                  enabled:
                    parseThresholdSettings[thresholdSettingKey].min.enabled,
                  value: parseThresholdSettings[thresholdSettingKey].min.value
                }
              }
            });
          }
        }
      }
      self[keyName] = self.mst_graph[keyName];
    } else {
      // Key名が同じstateにデータを代入する
      self[keyName] = self.mst_graph[keyName];
    }
  });

  if (self.alertHistory) {
    self.displayAlertHistory = Object.assign([], self.alertHistory);
    self.displayAlertHistory.reverse();
  }
  if (!self.alertHistory) {
    self.alertHistory = [];
  }
  if (self.unconfirmedAlert) {
    self.displayUnconfirmedAlert = Object.assign([], self.unconfirmedAlert);
    self.displayUnconfirmedAlert.reverse();
  }
  if (!self.unconfirmedAlert) {
    self.unconfirmedAlert = [];
  }

  self.dynamoRange = self.mst_graph.range;
  self.dynamoThreshold = self.mst_graph.threshold;
  if (!self.dynamoRange) {
    self.dynamoRange = defaultRange;
  }
  if (!self.dynamoThreshold) {
    self.dynamoThreshold = defaultThreshold;
  }

  if (!self.partitionKeyType) {
    self.partitionKeyType = "string";
  }
  if (!self.sortKeyType) {
    self.sortKeyType = "string";
  }
  self.tableName = self.mst_graph.table;
  self.reloadInterval = Number(self.mst_graph.updateInterval);
  self.searchPartition = self.mst_graph.targetPartitionKey;
  self.searchAttribute = self.mst_graph.targetAttribute;
  // CSVダウンロード画面の初期値設定
  self.downloadCsvPartitionKey = self.mst_graph.targetPartitionKey;

  // targetAttributesに保存されている表示対象キーを先頭に持ってくる
  if (self.attributes && self.targetAttributes) {
    const includeTargetAttributeKeys: string[] = [];
    const NotIncludeTargetAttributeKeys: string[] = [];
    self.attributes.map((attribute: string) => {
      if (self.targetAttributes.includes(attribute)) {
        includeTargetAttributeKeys.push(attribute);
      } else {
        NotIncludeTargetAttributeKeys.push(attribute);
      }
    });
    self.attributes = includeTargetAttributeKeys.concat(
      NotIncludeTargetAttributeKeys
    );
  }

  if (self.targetAttributes === null) {
    self.targetAttributes = [self.attributes[0]];
  }

  self.attributes.map((val: string) => {
    self.latestAttributeValues[val] = "-";
  });

  // 有償ユーザでない場合、メール発報はフロントエンド側に強制変更
  if (self.paid !== true) {
    self.changeAlertSwitch = false;
  }
}
